import { message, Select } from "antd"
import React, { useEffect, useState } from "react"
import DropdownService from "src/services/DropdownService"
import PublicService from "src/services/PublicService"
import WarehouseService from "src/services/WarehouseService"

const removeVietnameseTones = str => {
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // bỏ dấu
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D")
    .toLowerCase()
}
const PublicSelectCountry = ({ value, onChange, disabled, style={ height: "36px"}}) => {
  const [countries, setCountries] = useState([])

  useEffect(() => {
    fetchCountries()
  }, [])

  const fetchCountries = async () => {
    try {
      // const response = await DropdownService.getListAllCountryToB2b()
      const response = await PublicService.getDropdownCountry()
      setCountries(response?.success || [])
    } catch (error) {
      console.error("Lỗi khi lấy danh sách quốc gia", error)
      message.error("Không thể lấy danh sách quốc gia")
    }
  }

  return (
    <Select
      placeholder="Chọn quốc gia"
      title="Chọn quốc gia"
      allowClear
      value={value}
      onChange={onChange}
      disabled={disabled}
      style={style}
      showSearch
      filterOption={(input, option) => {
        const inputNormalized = removeVietnameseTones(input)
        const optionText = removeVietnameseTones(option.children)
        return optionText.includes(inputNormalized)
      }}
    >
      {/* {countries.map(country => (
        <Select.Option key={country.country.ID} value={country.country.ID}>
          {country.country.title}
        </Select.Option>
      ))} */}
        {countries.map(country => (
        <Select.Option key={country.ID} value={country.ID}>
          {country.title}
        </Select.Option>
      ))}
    </Select>
  )
}

export default PublicSelectCountry
